/**
 * Formerly in the main.js file, it'll now be the training component's responsibility to call 
 * this function and set the tallies.
 * 
 * This file has grown — we should clean things up a bit by refactoring all these functions to export
 * once at the end.
 * 
 * @todo refactor this file so the other functions are constants that are also exported here.
 */
function getTrainingTallies (data) {
  let counts = {
    total: 0,
    complete: 0,
    notComplete: 0,
    exempt: 0
  }

  let enumerableData = data.hasOwnProperty("data") ? data.data : data

  enumerableData.forEach(function(row) {
    counts.total = counts.total + 1

    switch(row.TrainingStatusIconId) {
      case '2':
      case '3':
        counts.complete = counts.complete + 1
        break;
      case '1':
        counts.notComplete = counts.notComplete + 1
        break;
      case '4':
        counts.exempt = counts.exempt + 1
    }
  })
  
  return counts
}

function isLastPageTest(lastPageString) {
  return typeof lastPageString === 'string' && lastPageString === "true" || typeof lastPageString === 'boolean' && lastPageString
}

export {
  getTrainingTallies,
  isLastPageTest,
}